import { render, staticRenderFns } from "./CheckDocuments.vue?vue&type=template&id=3821c1fe&scoped=true"
import script from "./CheckDocuments.vue?vue&type=script&lang=js"
export * from "./CheckDocuments.vue?vue&type=script&lang=js"
import style0 from "./CheckDocuments.vue?vue&type=style&index=0&id=3821c1fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3821c1fe",
  null
  
)

export default component.exports